import { FiltersContextProvider } from '@openx/components-filters/lib/context/FiltersContext';
import { Table, TableName } from '@openx/components-table/Table';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import type { CuratedDealBuyerDiscountApi } from '../../../types/curatedDealBuyerDiscount';
import { CuratedDealBuyerDiscountDetailsDrawer } from './CuratedDealBuyerDiscountDetailsDrawer';
import { CuratedDealBuyerDiscountsTopBar } from './CuratedDealBuyerDiscountsTopBar';
import { useCuratedDealBuyerDiscountChipFilters } from './hooks/useCuratedDealBuyerDiscountChipFilters';
import { useCuratedDealBuyerDiscountColumns } from './hooks/useCuratedDealBuyerDiscountColumns';
import { useCuratedDealBuyerDiscountListFetch } from './hooks/useCuratedDealBuyerDiscountListFetch';
import { useCuratedDealBuyerDiscountRowActions } from './hooks/useCuratedDealBuyerDiscountRowActions';

export const CuratedDealBuyerDiscountsList = () => {
  const { criteria, curatedDealBuyerDiscounts, handleCriteriaChange, handleFiltersChange, loading } =
    useCuratedDealBuyerDiscountListFetch();

  const filtersConfig = useCuratedDealBuyerDiscountChipFilters(criteria, handleFiltersChange);
  const columns = useCuratedDealBuyerDiscountColumns(criteria.filters?.phrase);
  const rowActions = useCuratedDealBuyerDiscountRowActions();
  const navigate = useNavigate();

  const handleRowClick = useCallback(
    ({ uid }: CuratedDealBuyerDiscountApi) => {
      navigate(`/discounts/${uid}/details`);
    },
    [navigate]
  );

  return (
    <FiltersContextProvider config={filtersConfig}>
      <CuratedDealBuyerDiscountsTopBar />

      <Table
        columns={columns}
        criteria={criteria}
        data={curatedDealBuyerDiscounts}
        loading={loading}
        name={TableName.CURATED_DEAL_BUYER_DISCOUNTS}
        onCriteriaChange={handleCriteriaChange}
        onRowClick={handleRowClick}
        rowActions={rowActions}
      />

      <CuratedDealBuyerDiscountDetailsDrawer />
    </FiltersContextProvider>
  );
};
